import { render } from "./ImportPayrollView.vue?vue&type=template&id=288030a2&scoped=true"
import script from "./ImportPayrollView.vue?vue&type=script&lang=js"
export * from "./ImportPayrollView.vue?vue&type=script&lang=js"

import "./ImportPayrollView.vue?vue&type=style&index=0&id=288030a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288030a2"]])

export default __exports__